import { Text, Button, H3, Spacer } from '@components';
import { BUTTON_TYPES, EMPTY_STATE_TYPES, EMPTY_STATE_IMAGE } from '@types';
import NothingHere from '@img/NothingHere.png';
import styles from './EmptyState.module.scss';
import { ElementType } from 'react';
import {
	ClipBoardIcon,
	EmptyTreesIcon,
} from '@img/icons';

type TEmptyStateProps = {
	type: EMPTY_STATE_TYPES;
	image: EMPTY_STATE_IMAGE;
	buttonText?: string;
	buttonType?: BUTTON_TYPES;
	buttonIcon?: ElementType;
	buttonAction?: () => void;
	title?: string;
	subTitle?: string;
}

export const EmptyState = (props: TEmptyStateProps) => {
	const {
		type,
		image,
		buttonText,
		buttonType,
		buttonIcon,
		buttonAction,
		title,
		subTitle,
	} = props;

	return (
		<div className={styles.emptyStateContainer}>
			{
				type === EMPTY_STATE_TYPES.FIRST_USE ?
					<>
						{
							image === 'TUMBLEWEED' &&
							<img alt={'Tumbleweed'} src={NothingHere} />
						}
						{
							image === 'CLIPBOARD' &&
							<ClipBoardIcon color1='var(--of-blue-700)' color2='#395370' />
						}
					</> :
					<>
						{
							image === 'TREES' &&
							<EmptyTreesIcon />
						}
					</>
			}
			<Spacer size={16} />
			<div className={styles.emptyStateMessageSection}>
				<H3>{title ? title : 'All clear, nothing to see here'}</H3>
				{
					subTitle && <>
						<Spacer size={8}/>
						<Text>{subTitle}</Text>
					</>
				}
				<Spacer size={20}/>
			</div>
			{
				type === EMPTY_STATE_TYPES.FIRST_USE &&
				buttonAction &&
				buttonText &&
				<Button
					onClick={buttonAction}
					type={buttonType || BUTTON_TYPES.SECONDARY}
					text={buttonText}
					Icon={buttonIcon}
				/>
			}
		</div>
	);
}